module.exports = __webpack_public_path__ + "assets/icon-feeling-neutral-component.5c75c146.svg";